import { Box, Button, Dialog, DialogContent, DialogTitle } from "@mui/material";
import { StratifyDocument } from "@stratify/shared";
import React, { useState } from "react";
import { useSelector } from "react-redux";
import { selectInsightsByDocument } from "../store/insightsSelectors";
import { CopyAllInsightsButton } from "./CopyAllInsightsButton";
import { InsightForm } from "./InsightForm";
import { InsightList } from "./InsightList";
import { AIDisclaimer } from "../../../shared/components";

interface InsightsTabProps {
  document: StratifyDocument;
}

export const InsightsTab: React.FC<InsightsTabProps> = ({ document }) => {
  const [isFormOpen, setIsFormOpen] = useState(false);

  const handleOpenForm = () => setIsFormOpen(true);
  const handleCloseForm = () => setIsFormOpen(false);
  const insights = useSelector(selectInsightsByDocument(document.id));
  // Get the document category ID or default to "other"
  const documentCategoryId = document.metadata.category?.id || "OTHER";

  return (
    <Box>
      <AIDisclaimer sx={{ mt: 2, mb: 1 }} />
      <Box display="flex" justifyContent="space-between" gap={1} p={2}>
        <CopyAllInsightsButton insights={insights} />
        <Button variant="contained" onClick={handleOpenForm}>
          Add Insight
        </Button>
      </Box>

      <InsightList documentId={document.id} />

      <Dialog
        open={isFormOpen}
        onClose={handleCloseForm}
        maxWidth="md"
        fullWidth
      >
        <DialogTitle>Create New Insight</DialogTitle>
        <DialogContent>
          <Box mt={2}>
            <InsightForm
              documentId={document.id}
              documentCategoryId={documentCategoryId}
              onClose={handleCloseForm}
            />
          </Box>
        </DialogContent>
      </Dialog>
    </Box>
  );
};
